/**
 * Removes a trailing slash from a pathname (root "/" is preserved as-is).
 * Used to enforce that permanent SEO URLs never have a trailing slash.
 */
export const stripTrailingSlash = (pathname: string): string => {
  if (pathname === '/') return pathname;
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};

/**
 * Checks whether a pathname has a trailing slash that should trigger a redirect.
 */
export const hasTrailingSlash = (pathname: string): boolean => {
  return pathname !== '/' && pathname.endsWith('/');
};
